import Document from '@tiptap/extension-document';

export default Document.extend({
    // Document schema will start with an edge block (info box), and then
    // always followed by draggable nodes which might consist of other types
    // of blocks.
    content: 'edge_node draggable*'
});
